<template>
  <div 
  v-on:touchmove="preventPinchZoom($event)"
  id="app">
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  created: function () {
    // for dev environment
    if (this.$route.query.id_token) {
      this.onIdTokenInQuery()
    }
    if (this.$auth.authenticated()) {
      this.initializeData().then(
        siteId => {
          this.$router.push({name: 'cameras', params: { siteId: siteId }})
        },
        errMessage => {
          console.log(errMessage)
        }
      )
    }
  },
  data () {
    return {
      dummyEvent: null
    }
  },
  methods: {
    initializeData: function () {
      return this.$store.dispatch('initializeData')
    },
    onIdTokenInQuery: function () {
      this.$auth.storeIdTokenToLocalStorage(this.$route.query.id_token)
      this.$router.push(this.$route.name)
    },
    preventPinchZoom: function (event) {
      if (event.scale !== 1) {
        event.preventDefault()
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%; 
  height: 100%; 
  position: absolute; 
  touch-action: manipulation;
  overflow: hidden; 
}

.prevent-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.disable-click {
  user-select: none;
  opacity: 0.5;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.moveup-enter-active, .moveup-leave-active {
  transition: transform .5s;
}
.moveup-enter, .moveup-leave-to {
  transform: translateY(100%);
}
</style>



// WEBPACK FOOTER //
// App.vue?f80f4f00